import { render } from "./task_detail.vue?vue&type=template&id=387115f0&scoped=true"
import script from "./task_detail.vue?vue&type=script&lang=js"
export * from "./task_detail.vue?vue&type=script&lang=js"

import "./task_detail.vue?vue&type=style&index=0&id=387115f0&lang=less&scoped=true"
import "./task_detail.vue?vue&type=style&index=1&id=387115f0&lang=less"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387115f0"]])

export default __exports__